/**
 * Fetch local one-shot das páginas MOBILE (extraído do MobileResumo no #25a
 * pro MobilePnl reusar). Sem cache module-level: o refresh da casca remonta a
 * página e o hook refaz o fetch. Erro vira flag (ErroNote por card).
 */
import { useEffect, useState } from "react";

export interface FetchLocal<T> {
  data: T | null;
  erro: boolean;
  loading: boolean;
}

export function useFetchLocal<T>(fetcher: () => Promise<T>): FetchLocal<T> {
  const [st, setSt] = useState<FetchLocal<T>>({ data: null, erro: false, loading: true });
  useEffect(() => {
    let cancel = false;
    fetcher()
      .then((d) => !cancel && setSt({ data: d, erro: false, loading: false }))
      .catch(() => !cancel && setSt({ data: null, erro: true, loading: false }));
    return () => { cancel = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return st;
}
